import { Button } from '@mui/material';
import { TrashIcon } from '@diligentcorp/atlas-react-icons';
import { useTranslation } from 'react-i18next';

export type SLAsGridToolbarDeleteSLAProps = {
  onDeleteSLAClick: () => void;
};

export function SLAsGridToolbarDeleteSLA(props: SLAsGridToolbarDeleteSLAProps) {
  const { onDeleteSLAClick } = props;
  const { t } = useTranslation('settings');

  return (
    <Button
      onClick={onDeleteSLAClick}
      variant='text'
      startIcon={<TrashIcon />}
      data-testid='delete-sla-button'
    >
      {t('slaConfiguration.delete')}
    </Button>
  );
}
